import React, { Component } from "react"
import { connect } from "react-redux"
import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'
import { Panel, Row, Col } from 'react-bootstrap'
import OTPInput from './otpInput'
import { checkPhoneNumber, checkOTP, changePasswordOTP } from '../actions'

class ForgetPasswordPage extends Component {

    state = {
        phoneNumber: '',
        OTP: '',
        password: '',
        confirmPassword: '',
        step: 1,
        error: '',
        loading: false,
    }
    callback(step) {
        this.setState({
            step: step + 1,
            loading: false,
            error: '',
        })
    }
    callbackerr(err) {
        this.setState({ loading: false, error: err })
    }
    onSubmit(step) {
        switch (step) {
            case 1:
                if (!this.state.phoneNumber) {
                    this.setState({ error: 'กรอกข้อมูลไม่ครบ' })
                } else {
                    this.setState({ loading: true })
                    this.props.checkPhoneNumber(this.state.phoneNumber, () => this.callback(step), this.callbackerr.bind(this))
                }
                break;
            case 2:
                if ((this.state.OTP).length !== 6) {
                    this.setState({ error: 'กรอกข้อมูลไม่ครบ' })
                } else {
                    this.setState({ loading: true })
                    this.props.checkOTP(this.state.OTP, this.state.phoneNumber, () => this.callback(step), this.callbackerr.bind(this))
                }
                break;
            case 3:
                if (!this.state.password) {
                    this.setState({ error: 'กรอกข้อมูลไม่ครบ' })
                } else if (this.state.password !== this.state.confirmPassword) {
                    this.setState({ error: 'รหัสผ่านไม่ตรงกัน' })
                } else {
                    this.setState({ loading: true })
                    this.props.changePasswordOTP(this.state.phoneNumber, this.state.password, () => this.callback(step), this.callbackerr.bind(this))
                }
                break;
            default:
                this.props.history.push('/login')
                break;
        }
    }
    onInputChange(type, value) {
        let newState = {}
        if (!value) {
            newState.error = ''
        }
        newState[type] = value
        this.setState({ ...newState })
    }
    renderStepOne() {
        return (
            <div className="input-container">
                <small>เบอร์โทรศัพท์</small>
                <input
                    onChange={(e) => { this.setState({ phoneNumber: e.target.value }) }}
                    value={this.state.phoneNumber}
                    className="form-control input-text" placeholder="เบอร์โทรศัพท์*"
                    inputMode='numeric' pattern="[0-9]*" />
            </div>
        )
    }
    renderStepTwo() {
        return (
            <div>
                <OTPInput onChange={(OTPValue) => {
                    this.setState({ OTP: OTPValue })
                }} />
            </div>
        )
    }
    renderStepThree() {
        return (
            <div>
                <div className="input-container row">
                    <small>รหัสผ่านใหม่</small>
                    <div className='col-8 input-col'>
                        <input
                            onChange={(e) => { this.onInputChange('password', e.target.value) }}
                            value={this.state.password}
                            className="form-control input-text" placeholder="รหัสผ่าน*" type='password' />
                    </div>
                </div>
                <div style={{ padding: 5 }} />
                <div className="input-container row">
                    <small>ยืนยันรหัสผ่าน</small>
                    <div className='col-8 input-col'>
                        <input
                            onChange={(e) => { this.onInputChange('confirmPassword', e.target.value) }}
                            value={this.state.confirmPassword}
                            className="form-control input-text" placeholder="ยืนยันรหัสผ่าน*" type='password' />
                    </div>
                </div>
            </div>
        )
    }
    renderContent() {
        switch (this.state.step) {
            case 1:
                return this.renderStepOne()
            case 2:
                return this.renderStepTwo()
            case 3:
                return this.renderStepThree()
            default:
                return <div></div>
        }
    }

    render() {
        const disabled = this.state.loading,
            btnWording = this.state.step === 1
                ? 'ส่งรหัส OTP ไปที่มือถือ'
                : this.state.step === 4
                    ? 'เข้าสู่ระบบ'
                    : 'ยืนยัน',
            title = this.state.step === 1
                ? 'ลืมรหัสผ่าน'
                : this.state.step === 2
                    ? 'ใส่รหัส OTP 6 หลัก'
                    : this.state.step === 3
                        ? 'เปลี่ยนรหัสผ่านใหม่'
                        : 'เปลี่ยนรหัสผ่านสำเร็จ'
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg" style={{ height: '700px' }}>
                    <Row>
                        <Col md={3} sm={1} xs={0}>
                        </Col>
                        <Col md={6} sm={10} xs={12}>
                            <div style={{ padding: '10px', textAlign: 'center', marginTop: 25 }}>
                                <img src="../../static/images/logo_songsod_blue.png" style={{ width: '20%' }} />
                            </div>
                            <Panel style={{ backgroundColor: '#fafafa' }}>
                                <div className="section-message">
                                    <h3 className="section-message-content">{title}</h3>
                                </div>
                                {
                                    this.state.error ?
                                        <div style={{
                                            color: 'red',
                                            backgroundColor: '#ffcccc',
                                            textAlign: 'center',
                                            padding: 10,
                                        }} className='error-alert'>
                                            {this.state.error}
                                        </div>
                                        : ''
                                }
                                {
                                    this.renderContent()
                                }
                                <button className={'btn btn-primary max-width'}
                                    onClick={() => {
                                        this.onSubmit(this.state.step)
                                    }}
                                    disabled={disabled}
                                    style={{ marginTop: 30 }}
                                >
                                    {btnWording}
                                </button>
                                <br />

                            </Panel>
                        </Col>
                    </Row>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}

export default connect(null, { checkPhoneNumber, checkOTP, changePasswordOTP })(ForgetPasswordPage)


// WEBPACK FOOTER //
// ./src/components/forgetPasswordPage.js